import { render } from "./Venues.vue?vue&type=template&id=5347f926"
import script from "./Venues.js?vue&type=script&lang=js"
export * from "./Venues.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__